const tab_sections = {
    overview: 'ภาพรวม',
    authentication: 'การพิสูจน์ตัวตน',
    authorization: 'การให้สิทธิ์',
    users: 'ผู้ใช้',
    developer: 'นักพัฒนา',
    tenant: 'ผู้เช่า',
};
export default Object.freeze(tab_sections);
